export default __webpack_public_path__ + "static/media/mobile_back.01c6b1bc.png";